// ─── Workshop Truck Availability Tracker ───
// useToast – Global toast notification state manager
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

import { useState, useCallback } from 'react'
import type { ToastMessage } from '@/types'

interface UseToastReturn {
  toasts: ToastMessage[]
  addToast: (type: ToastMessage['type'], message: string) => void
  dismissToast: (id: string) => void
}

export function useToast(): UseToastReturn {
  const [toasts, setToasts] = useState<ToastMessage[]>([])

  const addToast = useCallback((type: ToastMessage['type'], message: string) => {
    const id = crypto.randomUUID()
    const newToast: ToastMessage = { id, type, message }
    setToasts((prev) => [...prev, newToast])

    // Auto‑dismiss after 4 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id))
    }, 4000)
  }, [])

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  return { toasts, addToast, dismissToast }
}
